import React, { useState, useRef } from "react";
import styled from "styled-components";
import { Row, Col, Modal, ModalBody } from "reactstrap";
import RebelExperienceInputFormTab from "../cost-summary/rebel-experience-tab-form-input";
import { currencyOptions } from "../../../../utils/budget-tool-specific";
import { RebelColors, RebelCard, RebelButton, RebelSecondaryButton } from "../../../../styles/rebel-experiences";
import { useEffect } from "react";
import { GetDB, generateGUID } from "../../../../utils/database/firebase-budget-tool";
import { listenToDocument, updateDocumentProperty } from "../../../../utils/firestore-functions";
import firebase from "firebase/compat/app";
import RebelSummaryTabForm from "./rebel-summary-tab-form";
import RebelClientOutput from "./rebel-client-output";
import RebelFormInput from "../components/rebel-form-input";
import RebelFormInputTripLength from "../components/rebel-form-input-triplength";


const RebelExperienceGuideInput = (props) => {

    const saveRetreatCostsRef = useRef(null);

    const [data, setData] = useState(
        {   title: {value: "", invalid: false, required: true},
            attendees: {value: 8, invalid: false, required: true},
            tripLength: {value: 0, invalid: false, required: true},
            currency: {value: "USD$", invalid: false, required: true},
            contingency: {value: 5, invalid: false, required: true},
            experiences: {value: {}, invalid: false, required: true},
            overhead: {value: 5, invalid: false, required: true},
            overheadPercent: {value: true, invalid: false, required: false},
            margin: {value: 250, invalid: false, required: true},
            marginPercent: {value: false, invalid: false, required: false},
            occupancy: {value: "Single Occupancy", invalid: false, required: false},
            notes: {value: "", invalid: false, required: false},
            numBreakfast: {value: 0, invalid: false, required: true},
            numLunch: {value: 0, invalid: false, required: true},
            numDinner: {value: 0, invalid: false, required: true},
            numAlcohol: {value: 0, invalid: false, required: true},
    })

    const budgetDB = GetDB();

    const occupancyChecked = (value) => {
        if (value === "Double Occupancy"){
            return true;
        }
        return false;
    }

    const toggleOccupancy = () => {
        if (data.occupancy.value === "Single Occupancy"){
            setData({
                ...data,
                occupancy:{
                    ...data.occupancy,
                    value: "Double Occupancy"
                }
            });
        }
        else{
            setData({
                ...data,
                occupancy:{
                    ...data.occupancy,
                    value: "Single Occupancy"
                }
            });
        }
    }

    const toggleMarginPercentage = () => {
        console.log("Toggling Margin Percentage");
        console.log(data.marginPercent.value);
        if (data.marginPercent.value){
            setData({
                ...data,
                marginPercent: {
                    ...data.marginPercent,
                    value: false
                }
            });
        }
        else{
            setData({
                ...data,
                marginPercent: {
                    ...data.marginPercent,
                    value: true
                }
            });
        }
    }

    const toggleOverheadPercentage = () => {
        if (data.overheadPercent.value){
            setData({
                ...data,
                overheadPercent: {
                    ...data.overheadPercent,
                    value: false
                }
            });
        }
        else{
            setData({
                ...data,
                overheadPercent: {
                    ...data.overheadPercent,
                    value: true
                }
            });
        }
    }

    const [tabKey, setTabKey] = useState(0);
    const [copyAlert, setCopyAlert] = useState(false);

    useEffect (() =>{
        var unsubscribe = listenToDocument(budgetDB, "rebelExperienceGuides", props.id, SetGuideContent);
        return unsubscribe;
    }, [])

    const validate = (value) => {
        if (value === undefined) {
            return true;
        } else {
            return false;
        }
    }

    const SetGuideContent = (guide) => {
        let newData = {...data};
        newData.title.value = guide.title;
        newData.attendees.value =  guide.attendees;
        newData.tripLength.value = guide.tripLength;
        newData.experiences.value = guide.experiences;
        newData.contingency.value = guide.contingency;
        newData.currency.value = guide.currency;
        newData.occupancy.value = guide.occupancy;
        if (guide.occupancy !== undefined){
            newData.occupancy.value = guide.occupancy;
        }
        if (guide.overhead !== undefined){
            newData.overhead.value = guide.overhead;
        }
        if (guide.margin !== undefined){
            newData.margin.value = guide.margin;
        }
        if (guide.notes !== undefined){
            newData.notes.value = guide.notes;
        }
        if (guide.marginPercent !== undefined){
            newData.marginPercent.value = guide.marginPercent;
        }
        if (guide.overheadPercent !== undefined){
            newData.overheadPercent.value = guide.overheadPercent;
        }
        if (guide.numBreakfast !== undefined){
            newData.numBreakfast.value = guide.numBreakfast;
        } else {
            // Set default based on trip length
            newData.numBreakfast.value = guide.tripLength || 0;
        }
        if (guide.numLunch !== undefined){
            newData.numLunch.value = guide.numLunch;
        } else {
            // Set default based on trip length
            newData.numLunch.value = Math.max(0, (guide.tripLength || 0) - 1);
        }
        if (guide.numDinner !== undefined){
            newData.numDinner.value = guide.numDinner;
        } else {
            // Set default based on trip length
            newData.numDinner.value = guide.tripLength || 0;
        }
        if (guide.numAlcohol !== undefined){
            newData.numAlcohol.value = guide.numAlcohol;
        } else {
            // Set default based on trip length
            newData.numAlcohol.value = guide.tripLength || 0;
        }
        setData(newData);
    }

    const createNewExperience = () => {

        const newTitle = "R.E.B.E.L Experience " + (Object.keys(data.experiences.value).length +  1);
        const timeStamp = firebase.firestore.Timestamp.now()

        let newExperience = {
            title: newTitle,
            destCurrency: "USD$",
            base: 1,
            convert: 1,
            location: "",
            timeCreated: timeStamp,
            id: generateGUID(),
            villaId: "",
            villaName: "",
            villaRentalFee: 0,
            cleaningFee: 0,
            flightCost: 0,
            costPerTransportation: 0,
            transportation: {},
            costPerActivity: 0,
            numActivities: 0,
            costPerBreakfast: 0,
            numBreakfast: 0,
            costPerLunch: 0,
            numLunch: 0,
            costPerDinner: 0,
            numDinner: 0,
            costPerCoffee: 0,
            numCoffee: 0,
            costPerAlcohol: 0,
            numAlcohol: 0,
            av: {value: 0, pp: "per day"},
            setupFee: {value: 0, pp: "per day"},
            roomRental: {value: 0, pp: "per day"},
            numMeetings: 0,
            miscellaneousCosts: [],
            index: Object.keys(data.experiences.value).length + 1,
            notes: "",
            distanceFromAirport: "",
            numberOfBedrooms: 0,
            villaURL: "",
            nearestCity: "",
            distanceToCity: "",
        }
        updateGuideDetails(props.id);
        updateDocumentProperty(budgetDB, "rebelExperienceGuides", props.id, "experiences." + newExperience.id, newExperience);
        setTabKey(Object.keys(data.experiences.value).length+1);
    }

    const handleSubmit = (e, index) => {
        e.preventDefault();
        // focus on next input box
    }

    const updateGuideDetails = (id) => {
        updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "title", data.title.value);
        updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "attendees", data.attendees.value);
        updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "tripLength", data.tripLength.value);
        updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "currency", data.currency.value);
        updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "contingency", data.contingency.value);
        if (data.occupancy.value !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "occupancy", data.occupancy.value);
        }
        if (data.overhead !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "overhead", data.overhead.value);
        }
        if (data.overheadPercent !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "overheadPercent", data.overheadPercent.value);
        }
        if (data.margin !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "margin", data.margin.value);
        }
        if (data.marginPercent !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "marginPercent", data.marginPercent.value);
        }
        if (data.index !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "index", data.index);
        }
        if (data.notes !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "notes", data.notes);
        }
        if (data.numBreakfast !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "numBreakfast", data.numBreakfast.value);
        }
        if (data.numLunch !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "numLunch", data.numLunch.value);
        }
        if (data.numDinner !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "numDinner", data.numDinner.value);
        }
        if (data.numAlcohol !== undefined){
            updateDocumentProperty(budgetDB, "rebelExperienceGuides", id, "numAlcohol", data.numAlcohol.value);
        }
    }

    const saveAll = () => {
        updateGuideDetails(props.id);
        if (saveRetreatCostsRef.current) {
            saveRetreatCostsRef.current();
        }
    }

    const copyURL = () => {
        let url = window.location.href.replace("edit/", "");
        navigator.clipboard.writeText(url);
        setCopyAlert(!copyAlert);
    }


    return (
        <React.Fragment>
            <RebelModal isOpen={copyAlert} toggle={() => setCopyAlert(!copyAlert)}>
                <RebelModalBody toggle={() => setCopyAlert(!copyAlert)}>
                    <Row style={{display: "flex", alignItems: "center"}}>
                        <Col>
                            <p style={{margin: "0px", color: RebelColors.primary}}>URL copied to clipboard!</p>
                        </Col>
                        <Col style={{display: "flex", justifyContent: "flex-end"}}>
                        <RebelButton style={{margin: "0px"}}onClick={() => setCopyAlert(!copyAlert)} >
                            Okay
                        </RebelButton>
                    </Col>
                    </Row>

                </RebelModalBody>
            </RebelModal>
            <Row>
                <Col>
                    <RebelCard onSubmit={e => { handleSubmit(e, 1); }}>
                        {props.client && <RebelClientOutput data={data}/>}

                        {!props.client && <React.Fragment>
                        <Row>
                            <Col>
                                <RebelFormInput title="Guide Name"
                                            id="title" data={data}
                                            setData={(x) => setData(x)}
                                            type="text"/>
                            </Col>
                            <Col lg="auto" style={{display: "flex", alignItems: "flex-end", paddingLeft: "0px"}}>
                                    <RebelSecondaryButton style={{margin: "0px 0px 16px 0px"}} onClick={() => copyURL()}>Copy Client URL</RebelSecondaryButton>
                            </Col>
                            <Col lg="auto" style={{display: "flex", alignItems: "flex-end", paddingLeft: "0px"}}>
                                    <RebelButton style={{margin: "0px 0px 16px 0px"}} onClick={() => saveAll()}>Save</RebelButton>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="1">
                                <RebelFormInput title="Attendees"
                                    id="attendees" data={data}
                                    setData={(x) => setData(x)}
                                    type="number"/>
                            </Col>
                            <Col lg="3">
                                <RebelFormInputTripLength title="Trip Length"
                                            id="tripLength" data={data}
                                            setData={(x) => setData(x)}
                                            type="number"/>

                            </Col>
                            <Col lg="2">
                                <RebelFormInput title="Client Currency"
                                            id="currency"
                                            data={data}
                                            setData={(x) => setData(x)}
                                            type="select"
                                            options={currencyOptions()}/>
                            </Col>
                        </Row>
                        <MealConfigCard>
                            <MealConfigHeader>Meal Configuration</MealConfigHeader>
                            <Row>
                                <Col lg="3">
                                    <RebelFormInput title="Number of Breakfasts"
                                                id="numBreakfast"
                                                data={data}
                                                setData={(x) => setData(x)}
                                                type="number"/>
                                </Col>
                                <Col lg="3">
                                    <RebelFormInput title="Number of Lunches"
                                                id="numLunch"
                                                data={data}
                                                setData={(x) => setData(x)}
                                                type="number"/>
                                </Col>
                                <Col lg="3">
                                    <RebelFormInput title="Number of Dinners"
                                                id="numDinner"
                                                data={data}
                                                setData={(x) => setData(x)}
                                                type="number"/>
                                </Col>
                                <Col lg="3">
                                    <RebelFormInput title="Number of Drinks"
                                                id="numAlcohol"
                                                data={data}
                                                setData={(x) => setData(x)}
                                                type="number"/>
                                </Col>
                            </Row>
                        </MealConfigCard>
                        <Row>
                            <Col lg="2">
                                <RebelFormInput title="Contingency"
                                            id="contingency"
                                            data={data}
                                            setData={(x) => setData(x)}
                                            type="number"
                                            contingency
                                            />
                            </Col>
                            {data.overhead !== undefined && <Col lg="3">
                                <RebelFormInput title="Administrative & Management Fee"
                                            id="overhead"
                                            data={data}
                                            setData={(x) => setData(x)}
                                            type="number"
                                            contingency
                                            labelCanBeToggled
                                            labelIsPercentage={data.overheadPercent.value}
                                            onClick={() => {
                                                toggleOverheadPercentage();
                                            }}
                                            />
                            </Col>}
                            {data.margin !== undefined && <Col lg="3">
                                <RebelFormInput title="Per Person Planning Fee"
                                            id="margin"
                                            data={data}
                                            setData={(x) => setData(x)}
                                            type="number"
                                            contingency
                                            labelCanBeToggled
                                            labelIsPercentage={data.marginPercent.value}
                                            onClick={() => {
                                                toggleMarginPercentage();
                                            }}
                                            />
                            </Col>}
                        </Row></React.Fragment>}
                        <Row id="tab-header">
                            <Col>
                                {tabKey !== 0 && <RebelTabButton onClick={x => setTabKey(0)}>
                                    <TabTitle>Summary</TabTitle>
                                    <TabSubtitle style={{visibility: 'hidden'}}>&nbsp;</TabSubtitle>
                                </RebelTabButton>}
                                {tabKey === 0 && <RebelActiveTabButton>
                                    <TabTitle>Summary</TabTitle>
                                    <TabSubtitle active style={{visibility: 'hidden'}}>&nbsp;</TabSubtitle>
                                </RebelActiveTabButton>}
                                {data.experiences.value !== undefined && Object.entries(data.experiences.value).sort((a,b) => {

                                    return a[1].timeCreated - b[1].timeCreated;
                                }).map((experience, i) => {

                                    if (tabKey !== i+1) {
                                        return (
                                            <RebelTabButton key={i} onClick={x => setTabKey(i+1)}>
                                                <TabTitle>{experience[1].title}</TabTitle>
                                                {experience[1].location ? (
                                                    <TabSubtitle>{experience[1].location}</TabSubtitle>
                                                ) : (
                                                    <TabSubtitle style={{visibility: 'hidden'}}>&nbsp;</TabSubtitle>
                                                )}
                                            </RebelTabButton>
                                        )
                                    } else {
                                        return (
                                            <RebelActiveTabButton key={i}>
                                                <TabTitle>{experience[1].title}</TabTitle>
                                                {experience[1].location ? (
                                                    <TabSubtitle active>{experience[1].location}</TabSubtitle>
                                                ) : (
                                                    <TabSubtitle active style={{visibility: 'hidden'}}>&nbsp;</TabSubtitle>
                                                )}
                                            </RebelActiveTabButton>
                                        )
                                    }
                                })}

                                {!props.client && <RebelTabButton onClick={x => createNewExperience(x)}>
                                        <TabTitle>+</TabTitle>
                                        <TabSubtitle style={{visibility: 'hidden'}}>&nbsp;</TabSubtitle>
                                </RebelTabButton>}
                            </Col>
                        </Row>
                        {tabKey === 0 && <RebelSummaryTabForm guideData={data} client={props.client} guideId={props.id} />}

                        {data.experiences.value!== undefined && Object.entries(data.experiences.value).sort((a,b) => {

                                return a[1].timeCreated - b[1].timeCreated;
                            }).map((experience, i) => {

                            if (i+1 === tabKey) {
                                return (<RebelExperienceInputFormTab client={props.client}
                                            key={i+1}
                                            guideid={props.id}
                                            experience={experience}
                                            guideData={data}
                                            updateGuideDetails={(x) => updateGuideDetails(x)}
                                            setTabKey={x => setTabKey(x)}
                                            setSaveRetreatCostsRef={(fn) => saveRetreatCostsRef.current = fn}/>)

                            }
                        })}
                    </RebelCard>
                </Col>
            </Row>
        </React.Fragment>
    )

}
export default RebelExperienceGuideInput;

const RebelTabButton = styled.button`
    background-color: ${RebelColors.surface};
    border: 2px solid ${RebelColors.border};
    border-radius: 10px 10px 0px 0px;
    margin: 0px 1px 0px 1px;
    padding: 8px 20px;
    min-height: 52px;
    color: ${RebelColors.primary};
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    vertical-align: top;

    &:hover {
        background-color: ${RebelColors.surfaceLight};
        color: ${RebelColors.gold};
        border-color: ${RebelColors.gold};
    }

    &:focus {
        outline: none;
        border-color: ${RebelColors.gold};
    }
`;

const RebelActiveTabButton = styled.button`
    background-color: ${RebelColors.gold};
    color: #000000;
    border: 2px solid ${RebelColors.gold};
    border-radius: 10px 10px 0px 0px;
    margin: 0px 1px -1px 1px;
    padding: 8px 20px;
    min-height: 52px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    vertical-align: top;

    &:hover {
        background-color: ${RebelColors.gold};
        color: #000000;
        border: 2px solid ${RebelColors.gold};
    }

    &:focus {
        outline: none;
        border: 2px solid ${RebelColors.gold} !important;
        box-shadow: none !important;
    }
`;

const RebelModal = styled(Modal)`
    .modal-content {
        background-color: ${RebelColors.surface};
        border: 1px solid ${RebelColors.border};
        color: ${RebelColors.primary};
    }
`;

const RebelModalBody = styled(ModalBody)`
    background-color: ${RebelColors.surface};
    color: ${RebelColors.primary};
`;

const TabTitle = styled.div`
    line-height: 1.2;
`;

const TabSubtitle = styled.div`
    font-size: 11px;
    font-weight: 400;
    margin-top: 2px;
    opacity: 0.8;
    color: ${props => props.active ? '#000000' : RebelColors.primary};
    line-height: 1.2;
`;

const MealConfigCard = styled.div`
    background-color: ${RebelColors.surfaceLight};
    border: 1px solid ${RebelColors.border};
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
`;

const MealConfigHeader = styled.h4`
    color: ${RebelColors.gold};
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 16px;
    margin-top: 0;
`;
